import { SummaryProps } from "props/summary.props";

import Polygone from "./polygone.js";

export default function Summary(props: SummaryProps) {
  const year: string = new Date().getFullYear().toString();
  return (
    <div>
      <Polygone nodes={props.nodes}>
        {props.isUnderConstruction && (
          <>
            <label className="under-construction">under construction</label>
            <label className="cr">&copy; mehdibouzoubaa {year}</label>
          </>
        )}
      </Polygone>
    </div>
  );
}
